"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
var _cookie = require("@/utils/cookie");
var _badge = require("@/api/badge");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { showDebugLog, displayPopupMessage } from '@/utils/log'
var _default = exports.default = {
  props: {
    badges: {
      type: Array,
      default: () => {
        return {
          badges: []
        };
      }
    }
  },
  data() {
    return {
      myBadges: [],
      tableLoading: false
    };
  },
  async created() {
    const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
    this.tableLoading = true;
    const badgesAll = await (0, _badge.getBadgeList)(token, {
      page: 1,
      limit: 100,
      sorting: 'title'
    });
    for (let i = 0; i < this.badges.length; i++) {
      const badge = badgesAll.data.rows.find(element => element.id.toString() === this.badges[i]);
      if (badge) {
        this.myBadges.push(badge);
      }
    }
    this.tableLoading = false;
  }
};